import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Transaction, TransactionType } from '@contracts/interfaces/transaction.interfaces';
import { AccountService } from '../../services/account.service';
import { MatTableDataSource } from '@angular/material/table';
import { TransactionsService } from '../../services/transactions.service';
import { JobService } from '../../services/job.service';
import { Job } from '@contracts/interfaces/job.interface';
import { ACCOUNT } from '../../accounts';
import { InvoicesService } from 'src/app/services/invoices.service';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';
import { PDFService } from 'src/app/services/pdf.service';

@Component({
  selector: 'app-pending-revenue',
  templateUrl: './pending-revenue.component.html',
  styleUrls: ['./pending-revenue.component.scss']
})
export class PendingRevenueComponent implements OnInit {

  cashRevenueDataSource: MatTableDataSource<Transaction> | undefined;
  columnsToDisplay = [
    'status',
    'date',
    'description',
    'amount',
    'vat',
  ];

  loading = true;

  totalAmount = 0;

  expensesAcc = 0;
  wagesAcc = 0;

  revenueAcc = 0;
  revenueAccDataSource: MatTableDataSource<Transaction> | undefined;

  moveToExpenses = 0;
  moveToWages = 0;
  moveToGst = 0;
  moveToSavings = 0;

  transactions: Transaction[] = [];

  showMarkAsSortedButton = true;

  bulkBankTransfer = [];

  squareBalance = 0;
  squareTransactions: Transaction[] = [];
  squareTransactionsTotal = 0;
  squareSortedTotal = 0;
  squareFees = 0;
  squareTransfers: any[] = [];
  squareCheck = 0;

  squareRevenueAfter: any = null;
  squareRevenueInputs: any = [];

  ebayBalance = 0;
  ebayTransactions: Transaction[] = [];
  ebayTransactionsTotal = 0;
  ebayCheck = 0;

  g72RevenueBalance = 0;
  g72RevenueTransactions: Transaction[] = [];
  g72RevenueTotal = 0;
  g72RevenueDataSource: MatTableDataSource<Transaction> | undefined;

  ebayFeesTotal = 0;
  ebayOrderTotal = 0;
  ebayOrders: any[] = [];

  // Used to validate invoice numbers found in descriptions
  maxExistingInvoiceNumber: number | null = null;

  constructor(
    private transactionService: TransactionsService,
    private accountService: AccountService,
    private cdr: ChangeDetectorRef,
    private jobService: JobService,
    private invoiceService: InvoicesService,
    private pdfService: PDFService,
    ) { }

  private prefetchInvoiceNumberStats(callback?: () => void) {
    this.invoiceService.getAvailableInvoiceNumber().subscribe({
      next: (result: any) => {
        const nextNumber = result?.number;
        if (typeof nextNumber === 'number') {
          this.maxExistingInvoiceNumber = Math.max(0, nextNumber - 1);
        }
        if (callback) {
          callback();
        }
      },
      error: () => {
        // If we cannot determine the upper bound, still allow the workflow to continue.
        if (callback) {
          callback();
        }
      }
    });
  }

  reset () {
    this.loading = true;
    this.totalAmount = 0;

    this.revenueAcc = 0;
    this.wagesAcc = 0;
  
    this.moveToExpenses = 0;
    this.moveToWages = 0;
    this.moveToGst = 0;
    this.moveToSavings = 0;

    this.g72RevenueBalance = 0;
    this.g72RevenueTotal = 0;
    this.g72RevenueTransactions = [];

    this.transactions = [];

    this.squareRevenueInputs = [{
      description: "",
      amount: 0
    }];

    this.squareRevenueAfter = null;
  }

  ngOnInit(): void {
    this.reset();

    this.prefetchInvoiceNumberStats();

    this.showMarkAsSortedButton = true;
    
    this.accountService.find({accountNumber: {$in: [ACCOUNT.REVENUE, ACCOUNT.WAGES, ACCOUNT.G72REVENUE, ACCOUNT.G72EXPENSES]}}).subscribe((accounts: any) => {

      for (let account of accounts) {
        if (account.accountNumber == ACCOUNT.REVENUE) {
          this.revenueAcc = account.balance;
        }

        if (account.accountNumber == ACCOUNT.wagesAcc) {
          this.wagesAcc = account.balance;
        }

        if (account.accountNumber == ACCOUNT.G72REVENUE) {
          this.g72RevenueBalance = account.balance;
        }

        if (account.accountNumber == ACCOUNT.G72EXPENSES) {
          this.expensesAcc = account.balance;
        }
      }


      // G72 Revenue Account
      this.transactionService.find({["source.account"]: ACCOUNT.G72REVENUE}).subscribe((transactions: Transaction[]) => {
                
        for (let transaction of transactions) {
          if (!transaction.sorted && !transaction.ignore) {
            this.g72RevenueTransactions.push(transaction);
          }
        }

        this.g72RevenueDataSource = new MatTableDataSource<Transaction>(this.g72RevenueTransactions);
        this.cdr.detectChanges();
      });

      // Revenue Account unsorted transactions
      this.transactionService.find({["source.account"]: ACCOUNT.REVENUE, sorted: false}).subscribe((transactions: Transaction[]) => {

        for (let transaction of transactions) {

          if (!transaction.sorted && !transaction.ignore) {
            this.transactions.push(transaction);
          }

          if (transaction.status == 'unknown' && transaction.ignore == false) {
            this.showMarkAsSortedButton = false;
          }
        }

        this.revenueAccDataSource = new MatTableDataSource<Transaction>(this.transactions);
        this.cdr.detectChanges();
        
        for (let transaction of this.transactions) {
          this.totalAmount += transaction.amount;
        }

        this.moveToGst = this.totalAmount / 11;

        let temp = this.totalAmount - this.moveToSavings - this.moveToGst;
        if (this.expensesAcc < 100000) {
          let amountWeNeed = 100000 - this.expensesAcc;

          if (amountWeNeed > temp) {
            this.moveToExpenses = temp;
          } else {
            this.moveToExpenses = amountWeNeed;
          }
        }
        // if (this.wagesAcc < 150000) {
        //   this.moveToSavings = 0;
        // } else if (this.wagesAcc < 200000) {
        //   this.moveToSavings = (this.totalAmount - this.moveToGst - this.moveToExpenses) * 0.1;
        // } else if (this.wagesAcc < 300000) {
        //   this.moveToSavings = (this.totalAmount - this.moveToGst - this.moveToExpenses) * 0.15;
        // } else if (this.wagesAcc < 400000) {
        //   this.moveToSavings = (this.totalAmount - this.moveToGst - this.moveToExpenses) * 0.2;
        // } else if (this.wagesAcc > 400000) {
        //   this.moveToSavings = (this.totalAmount - this.moveToGst - this.moveToExpenses) * 0.3;
        // }

        this.moveToWages = this.totalAmount - this.moveToGst - this.moveToSavings - this.moveToExpenses;

        if (this.totalAmount == 0) {
          this.showMarkAsSortedButton = false;
        }
        
        this.loading = false;
      });
    })
  }

  openProofViewer(transactionHash: string, index: number, dataSource: any) {
    this.transactionService.openTransactionDialog(TransactionType.Revenue, transactionHash, index, dataSource, (r)=>{
      this.refresh();
    })
  }

  refresh() {
    this.reset();
    this.ngOnInit();
  }

  markAsSorted(transaction: Transaction) {
    transaction.sorted = true;
    this.transactionService.update(transaction).subscribe();
  }

  commit() {

    let transfers: any[] = [];
    if (this.moveToExpenses != 0) {
      transfers.push({
          srcAccount: ACCOUNT.REVENUE,
          destAccount: ACCOUNT.G72EXPENSES,
          amount: (this.moveToExpenses / 100).toFixed(2),
          transactionDescription: ""
        });
    }

    if (this.moveToGst != 0) {
      transfers.push({
        srcAccount: ACCOUNT.REVENUE,
        destAccount: ACCOUNT.BAS,
        amount: (this.moveToGst / 100).toFixed(2),
        transactionDescription: ""
      });
    }

    if (this.moveToWages != 0) {
      transfers.push({
        srcAccount: ACCOUNT.REVENUE,
        destAccount: ACCOUNT.WAGES,
        amount: (this.moveToWages / 100).toFixed(2),
        transactionDescription: ""
      });
    }

    if (this.moveToSavings != 0) {
      transfers.push({
        srcAccount: ACCOUNT.REVENUE,
        destAccount: ACCOUNT.RENT,
        amount: (this.moveToSavings / 100).toFixed(2),
        transactionDescription: ""
      });
    }

    // Revenue Disbursement
    this.jobService.create({
      job: Job.BANK_TRANSFER,
      date: {
        start: new Date()
      },
      data: {
        transfers
      }
    }).subscribe(r=> {
      for (let transaction of this.transactions) {
        transaction.sorted = true;
        this.transactionService.update(transaction).subscribe();
      }
    });
  }

  addCashRevenue() {
    this.squareRevenueInputs.push({
      description: "",
      amount: 0
    })
  }

  squareRevenueTransfers: any = [];
  checky() {
    this.squareRevenueTransfers = []
    this.squareRevenueAfter = this.squareBalance;

    for (let input of this.squareRevenueInputs) {
      if (input.amount != 0) {
        this.squareRevenueAfter -= input.amount;
        
        this.squareRevenueTransfers.push({
          srcAccount: ACCOUNT.CASH_REVENUE,  // Cash Revenue
          destAccount: ACCOUNT.REVENUE, // Revenue
          amount: input.amount/100,
          transactionDescription: input.description
        });
      }
    }
  }

  validateSquareRevenue () {
    this.jobService.create({
      job: Job.BANK_TRANSFER,
      date: {
        start: new Date()
      },
      data: {
        transfers: this.squareRevenueTransfers 
      }
    }).subscribe(r=> {
      // Also mark all cash revenue as sorted
  
    });
  }

  commitCashRevenue () {
    this.jobService.create({
      job: Job.BANK_TRANSFER,
      date: {
        start: new Date()
      },
      data: {
        transfers: this.squareRevenueTransfers 
      }
    }).subscribe(r=> {
      // Also mark all cash revenue as sorted
  
    });
  }

  validateEbayRevenue() {
    let balance = this.ebayBalance;

    // Add Fees to balance.
    balance += Math.abs(this.ebayFeesTotal);

    for (let transfer of this.ebayOrders) {
      balance -= transfer.amount;
    }

    return balance;
  }

  commitEbayRevenue() {
    if (this.validateEbayRevenue() != 0) {
      return;
    }

    let transfers: any[] = [];

    transfers.push({
      srcAccount: ACCOUNT.G72EXPENSES,  // Expenses
      destAccount: ACCOUNT.EBAY_REVENUE, // Ebay Revenue
      amount: Math.abs(this.ebayFeesTotal / 100).toFixed(2),
      transactionDescription: "Ebay Fees"
    });
    
    for (let transfer of this.ebayOrders) {
      transfers.push({
        srcAccount: ACCOUNT.EBAY_REVENUE,  // Ebay Revenue
        destAccount: ACCOUNT.REVENUE, // Revenue
        amount: (transfer.amount / 100).toFixed(2),
        transactionDescription: "inv " + transfer.invoice
      });
    }

    this.jobService.create({
      job: Job.BANK_TRANSFER,
      date: {
        start: new Date()
      },
      data: {
        transfers: transfers
      }
    }).subscribe(r=> {
      // Also mark all cash revenue as sorted
      
      for (let transaction of this.ebayTransactions) {
        transaction.sorted = true;

        this.transactionService.update(transaction).subscribe(r=>{});
      }

    });
  }

  openSquareDialog(transaction: Transaction) {
    this.transactionService.openSquareRevenueDialog(transaction, (data: any) => {
      this.ngOnInit();      
    })
  }

  openEbayDialog(transaction: Transaction) {
    this.transactionService.openEbayRevenueDialog(transaction, (data: any) => {
      this.ngOnInit();
    });
  }

  openCashDialog(transaction: Transaction) {
    this.transactionService.openCashRevenueDialog(transaction, (data: any) => {
      this.ngOnInit();
    });    
  }

  findInvoices() {
    const cutoffDate = this.getCutoffDate(90);
    const runSearch = () => {
      for (let transaction of this.transactions) {
        if ((transaction.status || "").toLowerCase() === "proven") {
          continue;
        }

        if (!this.isWithinAutoFindWindow(transaction, cutoffDate)) {
          this.updateStatus(transaction, "manual");
          continue;
        }

        const invoiceNumber = this.getInvoiceNumberFromDescription(transaction.description);
        this.updateStatus(transaction, "finding");

        if (invoiceNumber != null) {
          this.invoiceService.get(invoiceNumber).subscribe((invoice: InvoiceInterface) => {
            if (invoice != null && this.invoiceHasMatchingPayment(invoice, transaction.amount, cutoffDate)) {
              this.attachInvoiceToTransaction(transaction, invoice);
            } else {
              this.findInvoiceByPaymentAmount(transaction, cutoffDate);
            }
          }, () => this.findInvoiceByPaymentAmount(transaction, cutoffDate));
        } else {
          this.findInvoiceByPaymentAmount(transaction, cutoffDate);
        }
      }
    };

    // Ensure we have the current invoice count boundary before attempting to parse numbers.
    if (this.maxExistingInvoiceNumber === null) {
      this.prefetchInvoiceNumberStats(runSearch);
      return;
    }

    runSearch();
  }

  private findInvoiceByPaymentAmount(transaction: Transaction, cutoffDate: Date) {
    const paymentQuery: any = {
      "paymentsMade.amount": transaction.amount
    };

    this.invoiceService.find(paymentQuery).subscribe((invoices: InvoiceInterface[]) => {
      const invoice = invoices?.find(inv => this.invoiceHasMatchingPayment(inv, transaction.amount, cutoffDate));

      if (invoice) {
        this.attachInvoiceToTransaction(transaction, invoice);
      } else {
        this.updateStatus(transaction, "not found");
      }
    }, () => this.updateStatus(transaction, "not found"));
  }

  private invoiceHasMatchingPayment(invoice: InvoiceInterface, amount: number, cutoffDate: Date): boolean {
    if (!invoice?.paymentsMade || invoice.paymentsMade.length === 0) {
      return false;
    }

    return invoice.paymentsMade.some(payment => {
      const paymentDate = payment?.date ? new Date(payment.date) : null;
      const isRecent = paymentDate != null && !isNaN(paymentDate.getTime()) ? paymentDate >= cutoffDate : false;
      return payment.amount === amount && isRecent;
    });
  }

  private attachInvoiceToTransaction(transaction: Transaction, invoice: InvoiceInterface) {
    const attachWithHash = (hash: string) => {
      this.updateStatus(transaction, "attaching");
      this.transactionService.attachInvoice(transaction, hash, invoice.number).subscribe(() => {
        this.updateStatus(transaction, "proven");
      });
    };

    this.pdfService.check(invoice.pdf.file, invoice).subscribe((checkResult:any) => {
      if (checkResult.hash == null) {
        this.updateStatus(transaction, "generating");
        this.pdfService.generatePDF2(invoice.pdf.file, invoice).subscribe((generatedResult:any) => {
          attachWithHash(generatedResult.hash);
        });
      } else {
        attachWithHash(checkResult.hash);
      }
    });
  }

  // update status in table
  updateStatus (transaction: Transaction, status: string) {
    transaction.status = status;

    if (!this.revenueAccDataSource?.data) {
      return;
    }

    for (let i=0;i<this.revenueAccDataSource.data.length;i++) {
      if (this.revenueAccDataSource.data[i].source.sha1 == transaction.source.sha1) {
        this.revenueAccDataSource.data[i].status = status;
      }
    }
  }

  private getCutoffDate(days: number): Date {
    const cutoff = new Date();
    cutoff.setHours(0, 0, 0, 0);
    cutoff.setDate(cutoff.getDate() - days);
    return cutoff;
  }

  private isWithinAutoFindWindow(transaction: Transaction, cutoffDate: Date): boolean {
    const rawDate: any = transaction?.date || (transaction as any)?.transaction?.date;
    const txDate = rawDate ? new Date(rawDate) : null;
    if (!txDate || isNaN(txDate.getTime())) {
      return false;
    }
    return txDate >= cutoffDate;
  }

  private getInvoiceNumberFromDescription(input: string): number | null {
    if (!input) {
      return null;
    }

    const ceiling = this.maxExistingInvoiceNumber ?? Number.MAX_SAFE_INTEGER;
    const matches = input.match(/\b\d{3,6}\b/g) || [];
    const candidates = matches
      .map(m => Number(m))
      .filter(n => !isNaN(n) && n > 0 && n <= ceiling);

    if (candidates.length === 0) {
      return null;
    }

    // Prefer 4-digit invoice numbers first, then fall back to the first valid candidate.
    const fourDigit = candidates.find(n => n >= 1000 && n <= 9999);
    return fourDigit ?? candidates[0];
  }

  transactionStatus(transaction: Transaction) {
    console.log(transaction);
    if (transaction.squareTransactions != null) {
      return "square";
    } else if (transaction.ebayPayouts != null) {
      return "ebay";
    } else if (transaction.cashDeposit != null) {
      return "cash";
    } else {
      return "unknown";
    }
  }
}
